import React from "react";
import Button from "./components/Button";
import Icon from "./components/icons/Icon";

/**
 * Faengt Fehler beim Rendern ab.
 *
 * Ohne das zeigte die App bei einem einzigen kaputten Render eine weisse
 * Seite — mitten im Spiel blieb nur noch "beenden und neu starten". Jetzt
 * gibt es einen Ausweg, und der Spielstand liegt ohnehin im localStorage.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Unerwarteter Fehler:", error, info && info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="spiel">
        <main className="spiel-mitte">
          <div className="ansage">
            <span className="fehler-ikon">
              <Icon name="nochmal" size={28} />
            </span>
            <h1>Kurz gestolpert</h1>
            <p>Etwas ist schiefgelaufen. Punktestand und Verlauf sind gespeichert – Neuladen bringt dich zurück ins Spiel.</p>
          </div>
          <p className="hinweis-text fehler-detail">{String(this.state.error && this.state.error.message)}</p>
        </main>
        <div className="daumenzone">
          <Button variant="haupt" onClick={() => window.location.reload()}>
            <Icon name="nochmal" />
            Neu laden
          </Button>
          <Button variant="text" onClick={() => this.setState({ error: null })}>
            Nochmal versuchen
          </Button>
        </div>
      </div>
    );
  }
}
